import React from "react";
import {isEmpty} from "lodash";

export default function DetailSection({ details }) {
    const { title, info, status } = details;

    if (status.status === false) {
        return <div style={{
            fontSize: "14px",
            textAlign: "center"
        }}>Information not available</div>
    }

    return (
        <table style={{ width: "100%" }}>
            <tbody>
                {info.map((stat, i) => {
                    return (
                        <tr key={i}>
                            <td className="detail-label">
                                {stat.name}
                            </td>
                            <td>{stat.value}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
